import { flowSteps } from "@/mocks/gossipGuide";

export default function FlowSection() {
  return (
    <section id="flow" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-accent-600">投稿流程</p>
        <h2 className="mt-2 text-3xl text-foreground-950 md:text-4xl">从投稿到收钱的完整路径</h2>
        <p className="mt-3 text-foreground-600">
          吃瓜投稿想拿稳稿费，关键不是会写，而是每一步都不踩坑。按下面节奏走，把赚钱路径理顺。
        </p>
      </div>

      <ol className="relative mx-auto mt-12 grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-5">
        {flowSteps.map((s, idx) => (
          <li key={s.step} className="relative flex flex-col items-center text-center">
            {idx < flowSteps.length - 1 && (
              <i
                className="ri-arrow-right-line absolute left-[calc(100%-0.5rem)] top-5 hidden text-xl text-background-300 lg:block"
                aria-hidden="true"
              ></i>
            )}
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 font-display text-xl text-primary-600">
              {s.step}
            </span>
            <div className="mt-4 w-full rounded-2xl bg-background-50 p-5 ring-1 ring-background-200">
              <h3 className="font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}